export default "__VITE_ASSET__CnWMATpu__"